import { render, staticRenderFns } from "./VentaForm.vue?vue&type=template&id=242fb53d&scoped=true"
import script from "./VentaForm.vue?vue&type=script&lang=js"
export * from "./VentaForm.vue?vue&type=script&lang=js"
import style0 from "./VentaForm.vue?vue&type=style&index=0&id=242fb53d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "242fb53d",
  null
  
)

export default component.exports